import React from "react";
import { Outlet } from "react-router-dom";

function NetworkOperators() {
  return (
    <div>
      <Outlet />
    </div>
  );
}

export default NetworkOperators;
